import React from 'react';
import { Select, SelectProps } from 'antd';
import { noop } from 'lodash';


export type ThirdpartyAuthBeneficiarySelectProps = SelectProps<any> & {
  data?: Array<{tpid:number,tpname:String}>;
  value?: any;
  onChange?: (ThirdParty: {tpid:number,tpname:String}) => void;
  onSelected?: (ThirdParty: {tpid:number,tpname:String}) => void;
  disabled?: boolean;
  allowClear?: boolean;
  style?: any;
};

const ThirdpartyAuthBeneficiarySelect = ({
  data,
  value,
    onChange = noop,
  onSelected,
  ...otherProps
}: ThirdpartyAuthBeneficiarySelectProps) => {
  const handleChange: SelectProps<any>['onChange'] = (value, option) => {
    onChange(value);
    if (onSelected) {
      if (value) onSelected(data?.find((item) => item.tpid === value)!);
    }
  };

  return (
    <Select
      onChange={handleChange}
      {...otherProps}
      // loading={isLoading}
      allowClear
      value={value}
    >
      {data?.map((tp: any) => (
        <Select.Option value={tp.tpid} key={tp.tpid}>
          { tp.tpname}
        </Select.Option>
      ))}
    </Select>
  );
};

export default ThirdpartyAuthBeneficiarySelect;
